import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CheckmarkIconSmall: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.33496 9.83337L5.66829 12.1667L12.6683 4.83337"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckmarkIconM: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 14.5L8.5 18L19 7"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CheckmarkIconLarge: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6665 18.6665L11.3332 23.3332L25.3332 8.6665"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
